// extracted by mini-css-extract-plugin
export default {"wrapper":"lfCgwNuxr5IRjtBNFeUf","breadcrumb":"Y7mDMfN3ynYpHPCWJc5g","pageTitle":"dXBhe99yWyXFkkMSySxi","documentationLink":"FYikS95SCvp3r79krcz7"};